// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__tnoyY","header":"style__header__mgTqY","headerText":"style__headerText__n85oT","content":"style__content__tfal-"};